import styled from 'styled-components';

import { ShipActionVariant } from './ShipActionButton';

const variantStyles = {
  deposit: {
    background: 'rgba(80, 255, 120, 0.15)',
    borderColor: 'rgba(80, 255, 120, 0.4)',
    color: '#5f5',
    hoverBackground: 'rgba(80, 255, 120, 0.25)',
    hoverShadow: '0 0 15px rgba(80, 255, 120, 0.3)',
  },
  withdraw: {
    background: 'rgba(255, 180, 80, 0.15)',
    borderColor: 'rgba(255, 180, 80, 0.4)',
    color: '#ffb450',
    hoverBackground: 'rgba(255, 180, 80, 0.25)',
    hoverShadow: '0 0 15px rgba(255, 180, 80, 0.3)',
  },
};

export const ActionButton = styled.button<{ $variant: ShipActionVariant }>`
  flex: 1;
  padding: 8px 12px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;

  background: ${({ $variant }) => variantStyles[$variant].background};
  border-color: ${({ $variant }) => variantStyles[$variant].borderColor};
  color: ${({ $variant }) => variantStyles[$variant].color};

  &:hover {
    background: ${({ $variant }) => variantStyles[$variant].hoverBackground};
    box-shadow: ${({ $variant }) => variantStyles[$variant].hoverShadow};
  }

  @media (max-width: 600px) {
    font-size: 11px;
    padding: 5px 6px;
  }
`;
